export const BACKEND_KEY = 'DebtAccounts';
export const NO_CONTRIBUTION = 0;
export const DOLLAR_CONTRIBUTION = 1;
export const PERCENTAGE_CONTRIBUTION = 2;
export const BASE_ACCOUNT = {
  AccountId: null,
  frontEndId: null,
  InterestRate: 0,
};
